import React from 'react';

import Icon from 'components/shared/Icon/Icon';
import DateInputPicker from 'components/shared/DateInputPicker/DateInputPicker';

const parseDateOnlyString = (str) => {
  if (!str) return null;
  if (str instanceof Date) return str;
  if (typeof str === 'string' && /^\d{1,2}\/\d{1,2}\/\d{4}$/.test(str)) {
    const [m, d, y] = str.split('/').map(Number);
    return new Date(y, m - 1, d);
  }
  return new Date(str);
};

const DateSelector = ({
  isDate = false,
  isDateRange = false,
  isDateOnly = false,
  value,
  onChange,
  disabled = false
}) => {
  if (!isDate && !isDateRange) return null;

  if (isDateRange) {
    const startDate = value?.[0] || null;
    const endDate = value?.[1] || null;

    const handleStartDateChange = (date) => {
      const parsed = isDateOnly ? parseDateOnlyString(date) : date;
      onChange([parsed, endDate]);
    };

    const handleEndDateChange = (date) => {
      const parsed = isDateOnly ? parseDateOnlyString(date) : date;
      onChange([startDate, parsed]);
    };

    return (
      <div className="flex flex-col gap-3">
        <div className="flex items-end gap-1">
          <DateInputPicker
            required
            label="Start date"
            placeholder="Start date"
            buttonClassName="w-full"
            parentClassName="min-w-0"
            value={startDate}
            onChange={handleStartDateChange}
            disabled={disabled}
            isIcon={false}
            isClearable={false}
            iconIsRight
            isHint={false}
            hideCalendar
            isDateOnly={isDateOnly}
          />
          <div className="flex min-w-[28px] items-center justify-center">
            <Icon
              icon="minus-linear"
              color="neutral"
              size={20}
              shade={700}
              className="!mb-[10px]"
            />
          </div>
          <DateInputPicker
            required
            label="End date"
            placeholder="End date"
            buttonClassName="w-full"
            parentClassName="min-w-0"
            value={endDate}
            onChange={handleEndDateChange}
            disabled={disabled}
            isIcon={false}
            isClearable={false}
            iconIsRight
            isHint={false}
            hideCalendar
            isDateOnly={isDateOnly}
          />
        </div>
      </div>
    );
  }

  const handleDateChange = (date) => {
    const parsed = isDateOnly ? parseDateOnlyString(date) : date;
    onChange(parsed);
  };

  return (
    <div className="flex flex-col gap-2">
      <DateInputPicker
        required
        label="Date"
        placeholder="Select date"
        parentClassName="date-picker"
        hideCalendar
        value={value}
        onChange={handleDateChange}
        disabled={disabled}
        isClearable={false}
        iconIsRight
        isHint={false}
        isDateOnly={isDateOnly}
      />
    </div>
  );
};

export default DateSelector;
